import type React from "react";
import "./CourseCard.scss";
import { Link } from "react-router-dom";
import { formClass } from "../../../../shared/helpers";
import type { CourseType } from "../../types/CourseType";

type CourseCardProps = {
	course: CourseType;
};

export const CourseCard: React.FC<CourseCardProps> = ({ course }) => {
	const prefixClass = "course-card";
	return (
		<Link
			style={{
				textDecoration: "none",
				color: "black",
			}}
			to={`/courses/${course._id}`}
		>
			<div className={formClass(prefixClass)} key={course._id}>
				<img
					className={formClass(prefixClass, "image")}
					alt="course-image"
					src={course.image}
				/>
				<div className={formClass(prefixClass, "content")}>
					<p className={formClass(prefixClass, "title")}>{course.name}</p>
				</div>
			</div>
		</Link>
	);
};
